export enum ContratacaoTypes {
  CONTRATACAO_REQUEST = '@contratacao/CONTRATACAO_REQUEST',
  CONTRATACAO_SUCCESS = '@contratacao/CONTRATACAO_SUCCESS',
  CONTRATACAO_ERROR = '@contratacao/CONTRATACAO_ERROR',
}

export type ContratacaoActions =
  | ContratacaoRequestAction
  | ContratacaoSuccessAction
  | ContratacaoErrorAction

export type ContratacaoRequestPayload = {
  numberOfInstallments: number
  hasInsurance?: boolean
  callback: () => void
  errorCallback?: () => void
}

export interface ContratacaoRequestAction {
  type: ContratacaoTypes.CONTRATACAO_REQUEST
  payload: ContratacaoRequestPayload
}

export interface ContratacaoSuccessAction {
  type: ContratacaoTypes.CONTRATACAO_SUCCESS
}

export interface ContratacaoErrorAction {
  type: ContratacaoTypes.CONTRATACAO_ERROR
}
